module.exports = {"audiences":["englishMembers"],"experimentVersion":"v2","experimentAllocation":0.3,"defaultWeight":1,"defaults":{"showCTA":false},"autoTrack":true,"variations":[{"name":"textOnly","weight":1,"values":{"showCTA":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/powerUpRequestCTA.json
// module id = CZkE
// module chunks = 0